/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `alu` - ALU
* `briquette` - BRIQUETTE
* `alu_loose` - ALU_LOOSE
* `pet` - PET
* `pet_dummy_bale` - PET Dummy Bale
* `pet_dummy_bale_2` - PET Dummy Bale 2
* `pet_envases` - PET Envases
* `pet_loose` - PET_LOOSE
* `hdpe` - HDPE
* `other` - OTHER
 */
export type AIModelChoices = typeof AIModelChoices[keyof typeof AIModelChoices];


export const AIModelChoices = {
  alu: 'alu',
  briquette: 'briquette',
  alu_loose: 'alu_loose',
  pet: 'pet',
  pet_dummy_bale: 'pet_dummy_bale',
  pet_dummy_bale_2: 'pet_dummy_bale_2',
  pet_envases: 'pet_envases',
  pet_loose: 'pet_loose',
  hdpe: 'hdpe',
  other: 'other',
} as const;
